import { AppConfig } from ".";

export const config: AppConfig = {
  coreApi: {
    protocol: "https",
    host: "api.clinicos.ai",
  },
};
